import { createStore } from "vuex";
import { KahiState, KahiStore } from "@/store/modules/kahis";
import { NavigationState, NagivationStore } from "@/store/modules/navigations";

export interface RootState {
  kahi: KahiState;
  navigation: NavigationState;
}

export default createStore<RootState>({
  modules: {
    kahi: KahiStore,
    navigation: NagivationStore
  }
});
